module.exports = __webpack_public_path__ + "static/media/moon.acce19f0.svg";